import { Component, OnInit, OnDestroy, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { selectMessages } from '../../../store/toast/toast.reducer';
import { ToastActions } from '../../../store/toast/toast.actions';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-global-toast',
  standalone: true,
  imports: [ToastModule, TranslatePipe],
  templateUrl: './global-toast.component.html',
  styleUrl: './global-toast.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class GlobalToastComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly messageService = inject(MessageService);
  private readonly destroyRef = inject(DestroyRef);

  currentSeverity: string = '';

  private readonly iconMap: Record<string, string> = {
    success: 'assets/icons/toast/check.svg',
    info: 'assets/icons/toast/info.svg',
    warn: 'assets/icons/toast/warn.svg',
    error: 'assets/icons/toast/error.svg',
  };

  ngOnInit(): void {
    this.store
      .select(selectMessages)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((messages) => {
        if (messages && messages.length > 0) {
          const message = messages[0];
          this.currentSeverity = message.severity || 'info';
          this.messageService.clear();
          this.messageService.add(message);

          setTimeout(() => {
            this.store.dispatch(ToastActions.hideToast());
          }, message.life || 2500);
        }
      });
  }

  getIcon(severity: string): string {
    return this.iconMap[severity] || this.iconMap['info'];
  }
}
